const ENCanvas = {
	"Adicionar Canvas": "Add Canvas",
	"Alterar Canvas": "Change Canvas",
	"Atividades Chave": "Key Activities",
	"Canais": "Channels",
	"Canvas adicionado com sucesso": "Canvas successfully added",
	"Canvas alterado com sucesso": "Canvas successfully changed",
	"Canvas movido com sucesso": "Canvas successfully moved",
	"Canvas excluído com sucesso": "Canvas successfully deleted",
	"Como chegam até você e o que você entrega": "How they reach you and what you deliver",
	"Como você os ajuda": "How you help",
	"Como vocês interagem": "How they interact",
	"Digite o nome do canvas para excluí-lo": "Enter the name of the canvas to delete it",
	"Descrição do Post-It": "Description of the Post-It",
	"Deseja realmente excluir este Post-it": "Do you really want to delete the Post-It",
	"Deseja realmente excluir o canvas": "Do you really want to delete the canvas",
	"Editar Canvas": "Edit Canvas",
	"Erro ao adicionar canvas": "Error adding canvas",
	"Erro ao alterar canvas": "Error changing canvas",
	"Erro ao excluir canvas": "Error deleting canvas",
	"Erro ao excluir Post-It": "Error deleting Post-It",
	"Erro ao mover Post-It": "Error moving Post-It",
	"Estrutura de Custos": "Cost Structure",
	"Excluir Canvas": "Delete Canvas",
	"Excluir Post-it": "Delete Post-it",
	"Exclusão de canvas": "Delete Canvas",
	"Exclusão de Post-It": "Delete Post-It",
	"Explicação do quadrante": "Explanation of the quadrant",
	"Fontes de Receita": "Revenue Streams",
	"Indicadores Chave": "Key Indicators",
	"Inserção de Canvas": "Insert Canvas",
	"Mover Canvas": "Move Canvas",
	"Mover Post-it": "Move Post-it",
	"Nome do canvas não confere": "Canvas name does not match",
	"Nenhum Canvas selecionado": "No Canvas selected",
	"O que você entrega": "What you deliver",
	"O que você faz": "What you do",
	"O que você recebe": "What you receive",
	"Parceiros Chave": "Key Partners",
	"Post-it adicionado com sucesso": "Post-It successfully added",
	"Post-it alterado com sucesso": "Post-It successfully changed",
	"Post-it movido com sucesso": "Post-It successfully moved",
	"Post-It excluído com sucesso": "Post-It successfully deleted",
	"Problema": "Problem",
	"Proposição de Valor": "Value Proposition",
	"Proposta de Valor": "Value Propositions",
	"Quem ajuda você": "Who helps you",
	"Quem você ajuda": "Who you help",
	"Quem você é e o que possui": "Who you are and what you have",
	"Recursos Chave": "Key Resources",
	"Relação com o Cliente": "Customer Relationship",
	"Segmento de Clientes": "Customer Segment",
	"Segmentos de Mercado": "Customer Segments",
	"Selecione ou adicione um Canvas para visualizar os dados": "Select or add a Canvas to see the data",
	"Solução": "Solution",
	"Vantagem Competitiva": "Competitive Advantage"
};

export default ENCanvas;
